export enum PROMOTIONS_COMPETITIONS {
  SHILPA_SHAKTHI = 'Shilpa Shakthi Campaign',
  NIDAHAS_ADAHAS = 'Janashakthi Nidahas Adahas Art Competition',
}
